<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar
    [circleNumber]="5"
    (backClick)="goBack()"
    class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"
  ></app-sidebar>
  <!-- Header para móvil -->
  <app-header [circleNumber]="5" (backClick)="goBack()"></app-header>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="5" class="pt-[60px] md:pt-0"></app-subheader>

    <!-- Contenedor principal -->
    <div
      class="w-full xl:max-w-[800px] mx-auto px-4 sm:px-6 md:px-8 pb-28 md:pb-16"
      style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 88px)"
    >
      <h1
        class="teu-title text-2xl md:text-[32px] mb-3 text-left md:text-center"
      >
        Historial crediticio
      </h1>
      <p
        class="teu-subtitle text-sm md:text-base mb-6 text-left md:text-center text-gray-700"
      >
        Haremos una revisión de tu historial crediticio y sabremos si eres
        elegible inmediatamente.
      </p>

      <!-- Ilustración con dos tarjetas verdes (centrada y con ancho fijo por breakpoint) -->
      <div class="art-wrap mx-auto mb-6">
        <div class="flex flex-col items-center">
          <div [innerHTML]="teuLogoGreen"></div>
        </div>
      </div>

      <form [formGroup]="creditHistoryForm" (ngSubmit)="onSubmit()">
        <!-- Checkbox de consentimiento -->
        <div class="flex items-center justify-center gap-3 mb-6 w-full">
          <input
            id="consent"
            type="checkbox"
            class="mt-1 w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
            [class.border-red-300]="
              acceptConsent?.invalid && acceptConsent?.touched
            "
            formControlName="acceptConsent"
          />
          <label for="consent" class="text-sm text-gray-700">
            Acepto que Teu financiera revise mi historial crediticio.
          </label>
        </div>

        <!-- Mensaje de error -->
        <div
          *ngIf="acceptConsent?.invalid && acceptConsent?.touched"
          class="flex justify-center mb-4"
        >
          <small class="text-red-500 text-center">
            {{ getErrorMessage("acceptConsent") }}
          </small>
        </div>

        <!-- Botón Continuar -->
        <div class="flex justify-center">
          <button
            type="submit"
            class="btn-primary w-full max-w-[300px] h-[46px]"
            [disabled]="!canContinue"
            [class.opacity-50]="!canContinue"
            [class.cursor-not-allowed]="!canContinue"
          >
            Continuar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
